import { useMemo } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";

const CertificateTableData = (tutor) => {
  const columns = [
    { name: "sno", align: "center" },
    { name: "Certificate Name", align: "left" },
    { name: "Certificate Image", align: "center" },
  ];

  const rows = useMemo(() => {
    if (!tutor) return [];

    const certificates = tutor.certificates || [];

    return certificates.map((cert, index) => ({
      sno: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      "Certificate Name": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {cert?.certificateName || "N/A"}
        </ArgonTypography>
      ),
      "Certificate Image": cert.certificateImage ? (
        <ArgonBadge
          variant="gradient"
          badgeContent="View"
          color="info"
          size="xs"
          container
          component="a"
          href={cert.certificateImage}
          target="_blank"
          rel="noopener noreferrer"
        />
      ) : (
        <ArgonTypography variant="caption" color="text">
          Not Uploaded
        </ArgonTypography>
      ),
    }));
  }, [tutor]);

  return { columns, rows };
};

export default CertificateTableData;
